import React from 'react';

import { TextField } from 'src/components/basic';

import LANG_CONST from 'src/helpers/lang/const';
import model from './model';
import Signup from './Signup';

class SignupClinic extends Signup {
  type = 'clinic';
  renderName = () => {
    const apiStateId = 'signup';
    const { handleChange, handleBlur } = model;
    const createState = this.getApiState();
    const { invalid } = createState;

    return (
      <>
        <TextField
          autoFocus={true}
          template={6}
          name={'name'}
          value={model.input('name')}
          onChange={(n, v) => {
            model.resetApiState(apiStateId);
            handleChange(n, v);
          }}
          onFocus={this.onFocus}
          onBlur={handleBlur}
          label={LANG_CONST.clinic_name}
          invalid={invalid}
        />
      </>
    );
  };

  steps = () => {
    if (!this.props.bigForm) {
      return [
        this.props.router && { fields: [], content: () => <>{this.renderOptions()}</> },
        {
          fields: ['avatar', 'email'],
          content: () => (
            <>
              {this.renderAvatar()}
              {this.renderEmail()}
            </>
          )
        },
        {
          fields: ['name'],
          content: () => <>{this.renderName()}</>
        },
        {
          fields: ['username'],
          content: () => <>{this.renderUsername()}</>
        },
        {
          fields: ['password', 'password2'],
          content: () => <>{this.renderPw(true)}</>
        },
        {
          fields: ['phoneNumber'],
          content: () => <>{this.renderPhoneNumber()}</>
        }
      ].filter((c) => !!c);
    }

    return [
      this.props.router && { fields: [], content: () => <>{this.renderOptions()}</> },
      {
        fields: ['avatar', 'name', 'email', 'password'],
        content: () => (
          <>
            {this.renderAvatar()}
            {this.renderName()}
            {this.renderEmail()}
            {this.renderPw(false)}
          </>
        )
      },
      {
        fields: ['username'],
        content: () => <>{this.renderUsername()}</>
      },
      {
        fields: ['phoneNumber'],
        content: () => <>{this.renderPhoneNumber()}</>
      }
    ].filter((c) => !!c);
  };
}

export default SignupClinic;
